export const base_path = "/";
export const img_path = "/";
// export const API_BASE_URL = "http://localhost:3008/goutham-new/api/v1";

export const API_BASE_URL = "https://api.paybiafinance.com/goutham-new/api/v1";

export const formatDate = (dateString?: string): string => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date
    .toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");
};